module.exports = __webpack_public_path__ + "img/next.4b9c356c.svg";